import ai from '@/app/[locale]/(register_v2)/characters/create/_assets/ai.svg'
import { cn } from '@/app/_primitives/utils/cn'
import { ChevronUp } from 'lucide-react'
import Image from 'next/image'
import React, { useState } from 'react'

export function FilterSection(props: {
  title: string
  children: React.ReactNode
  defaultOpen?: boolean
  variant?: 'default' | 'collapsible'
}) {
  const { title, children, variant = 'default', defaultOpen = false } = props
  const [open, setOpen] = useState(() => {
    if (variant === 'collapsible') {
      return defaultOpen
    }

    return true
  })
  return (
    <div className="flex flex-col items-stretch gap-12">
      {variant === 'collapsible' && (
        <button
          onClick={() => setOpen((prev) => !prev)}
          type="button"
          className="flex flex-row items-center justify-between outline-none focus:outline-none">
          <p className="c-h7">{title}</p>
          <ChevronUp
            className={cn('h-20 w-20 stroke-[#8B8B8B]', {
              'rotate-180': !open,
            })}
          />
        </button>
      )}
      {variant === 'default' && (
        <p className="c-h7 flex items-center gap-6">
          {title}
          {title.toLocaleLowerCase() === 'color' && (
            <Image
              src={ai}
              alt="ai"
              width={37}
              height={20}
              className="h-20 w-37"
            />
          )}
        </p>
      )}
      {open && children}
    </div>
  )
}
